<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      v-if="trendShow"
      row-key="UserId"
      ref="list"
      unit="用户"
      :show-summary="true"
      :expand-all-row="true"
      :page="true"
      :show-checkbox="false"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"
      :getColumn="tableColumns"
      :getParams="tableParams"
      :trendColumn="trendColumn"
      :trendParams="trendParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport">导出</el-button>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>   
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/business/purchase/purchaseinvoicedetails/list.json";
import tableParam from "@/data/business/purchase/purchaseinvoicedetails/query.json";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      formApi: require("@/api/sy/formSetting").default,
      tableApi: require("@/api/sy/tableSetting").default,
      queryApi: require("@/api/sy/selectSetting").default,
      api: require("@/api/pu/puBillProduct").default,
      trendColumn: tableColumn.Data,
      tableColumns: tableColumn.Data,
      trendParams: tableParam.Data,
      tableParams: tableParam.Data,
      trendShow: true,
      params: {
        Name: "",
        LoginId: "",
        RoleId: null,
        Status: null,
      },
    };
  },

  mounted() {
    // console.log("1");
    //
    if (
      !this.$permission.canPrice("/business/purchase/purchaseinvoicedetails")
    ) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(
        (item) => item.tableName == "ReceiptAmount"
      );
      if (findIndex >= 0) list.tableList.splice(findIndex, 1);
      const findIndex0 = list.tableList.findIndex(
        (item) => item.tableName == "Price"
      );
      if (findIndex0 >= 0) list.tableList.splice(findIndex0, 1);
      const findIndex2 = list.tableList.findIndex(
        (item) => item.tableName == "TaxRate"
      );
      if (findIndex2 >= 0) list.tableList.splice(findIndex2, 1);
      const findIndex3 = list.tableList.findIndex(
        (item) => item.tableName == "Amount"
      );
      if (findIndex3 >= 0) list.tableList.splice(findIndex3, 1);
      const findIndex4 = list.tableList.findIndex(
        (item) => item.tableName == "TaxLimit"
      );
      if (findIndex4 >= 0) list.tableList.splice(findIndex4, 1);
      const findIndex5 = list.tableList.findIndex(
        (item) => item.tableName == "TaxPrice"
      );
      if (findIndex5 >= 0) list.tableList.splice(findIndex5, 1);
      const findIndex6 = list.tableList.findIndex(
        (item) => item.tableName == "TaxAmount"
      );
      if (findIndex6 >= 0) list.tableList.splice(findIndex6, 1);
      const findIndex7 = list.tableList.findIndex(
        (item) => item.tableName == "SettlementAmount"
      );
      if (findIndex7 >= 0) list.tableList.splice(findIndex7, 1);
    }
  },

  methods: {
    // getDateFunc(){
    //   return new Promise(resolve=>{
    //       this.api.list({'Code':'ProcessStage'}).then(res=>{
    //         resolve({Data:res.Data,Count:res.Count,Code:res.Code})
    //       })
    //   })
    // },
    //
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map((x) => x.tableName);
          var params = { ...listParams, Fields: fields.join(",") };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.detailExport(params).then((res) => {
            loading.close();
          });
        })
        .catch(() => {});
    },
    getFormData() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.fromData.map((item) => {
            item.show = ShowField.indexOf(item.field) !== -1 ? true : false;
          });
        }
      });
    },
    showTable() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.tableApi
        .list({ type: modeName })
        .then((res) => {
          if (res.Data === null || res.Data.length === 0) {
            return (this.trendShow = true);
          }
          if (res.Code == 0) {
            const ShowField = res.Data.map((x) => x.ShowField);
            this.tableColumns.forEach((item) => {
              const DataItem = res.Data.filter(
                (x) => x.ShowField == item.tableName
              );
              if (ShowField.indexOf(item.tableName) !== -1) {
                item.col.width = DataItem[0].ShowWidth;
                item.props.align = DataItem[0].Alignment;
                item.props.tooltip = DataItem[0].IsHidden;
              }
              // item.props.show = true
              item.props.show =
                ShowField.indexOf(item.tableName) !== -1 ? true : false;
            });
            this.trendShow = true;
            return (this.tableColumns = this.tableColumns.filter(
              (x) => x.props.show == true
            ));
          }
        })
        .then((res) => {
          this.getData();
        });
    },

    //
    showParams() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.queryApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.tableParams.forEach((item) => {
            const DataItem = res.Data.filter((x) => x.ShowField == item.field);
            if (ShowField.indexOf(item.field) !== -1) {
              item.col.labelWidth = DataItem[0].TagsWidth;
              item.col.width = DataItem[0].ShowWidth;
            }
            // item.props.show = true
            item.props.show =
              ShowField.indexOf(item.field) !== -1 ? true : false;
          });
          return (this.tableParams = this.tableParams.filter(
            (x) => x.props.show == true
          ));
        }
      });
    },

    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>